import { useQuery } from '@tanstack/react-query';
import { pmoDeliveryApi } from '../lib/api/pmo-delay.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * PMO デリバリー view。選択四半期の遅延トレンド・原因別内訳・リリースサマリーと、
 * 選択できる四半期の一覧をまとめて取得する。
 *
 * 進行中の四半期はサーバー側で都度計算され、終了した四半期は Q 終了時点で保存された
 * スナップショットが返る。未指定なら進行中の四半期。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business PMOデリバリーview（四半期選択・遅延トレンド・原因内訳・リリースサマリー）取得フック
 * @graph-connects /kpi/pmo-flow/delivery [calls] PMOデリバリーview取得
 */
export function usePmoDeliveryView(quarter?: string) {
  return useQuery({
    queryKey: queryKeys.pmoDelay.view(quarter),
    queryFn: () => pmoDeliveryApi.getView(quarter),
  });
}
